import Bugsnag from '@bugsnag/js';
import { getCurrentCulture as vpGetCurrentCulture } from '@vp/culture-resolution';
import { SupportedLocale } from './locales';

export const DEFAULT_DEVELOPMENT_LOCALE = 'en-US';

export function getCurrentCulture() {
    try {
        return vpGetCurrentCulture();
    } catch (e) {
        Bugsnag.notify(new Error('Failed to get current culture'));

        return DEFAULT_DEVELOPMENT_LOCALE;
    }
}

// TODO: This should probably be provided in context.

export function getCurrentCultureWithDev() {
    if (process.env.NODE_ENV === 'development') {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('locale')) {
            return searchParams.get('locale') || DEFAULT_DEVELOPMENT_LOCALE;
        }

        if (process.env.DEFAULT_LOCALE) {
            return process.env.DEFAULT_LOCALE as SupportedLocale;
        }

        const localeFromPath = getLocaleFromPath();
        return localeFromPath || DEFAULT_DEVELOPMENT_LOCALE;
    }

    return getCurrentCulture();
}

/**
 * Maps lowercase language code to ISO- locale codes.
 *
 * This is a local development workaround since `getCurrentCulture` is expected to work in prod. As
 * such, it does not need to be exhaustive, even though it is.
 */
const LANGUAGE_TO_LOCALE: Record<string, SupportedLocale> = {
    es: 'es-ES',
    en: 'en-US',
    fr: 'fr-FR',
    de: 'de-DE',
    it: 'it-IT',
    pt: 'pt-PT',
    nl: 'nl-NL',
    da: 'da-DK',
    fi: 'fi-FI',
    nb: 'nb-NO',
    sv: 'sv-SE',
};

function getLocaleFromPath(): SupportedLocale | undefined {
    const rawPath = window.location.pathname.split('/')[1]?.toLowerCase() ?? '';
    return LANGUAGE_TO_LOCALE[rawPath];
}
